// src/utils/theme.js

export const appTheme = {
  token: {
    // Primary colors (Indigo / Slate theme)
    colorPrimary: '#4F46E5',
    colorPrimaryHover: '#4338CA',
    colorSuccess: '#10B981',
    colorWarning: '#F59E0B',
    colorError: '#EF4444',
    colorInfo: '#3B82F6',
    
    // Typography
    fontSize: 14,
    fontFamily: "'Plus Jakarta Sans', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    
    // Spacing
    margin: 16,
    marginXS: 8,
    marginSM: 12,
    marginLG: 24,
    marginXL: 32,
    
    // Border radius
    borderRadius: 10,
    borderRadiusLG: 14,
    borderRadiusSM: 6,
    
    // Shadows
    boxShadow: '0 4px 20px -2px rgba(15, 23, 42, 0.06)',
    boxShadowSecondary: '0 10px 30px -10px rgba(79, 70, 229, 0.12)',
    
    // Colors
    colorBgBase: '#ffffff',
    colorBgContainer: '#ffffff',
    colorBgElevated: '#ffffff',
    colorBorder: '#E2E8F0',
    colorBorderSecondary: '#F1F5F9',
    colorTextBase: '#0F172A',
    colorTextSecondary: '#64748B',
    colorTextTertiary: '#94A3B8',
    
    // Component specific
    controlHeight: 42,
    controlHeightLG: 50,
    controlHeightSM: 34,
  },
  components: {
    Button: {
      controlHeight: 42,
      borderRadius: 10,
      fontWeight: 600,
      primaryShadow: '0 4px 14px 0 rgba(79, 70, 229, 0.35)',
    },
    Input: {
      controlHeight: 42,
      borderRadius: 10,
      fontSize: 14,
      colorBorder: '#E2E8F0',
      activeBorderColor: '#4F46E5',
    },
    Select: {
      controlHeight: 42,
      borderRadius: 10,
    },
    Table: {
      borderRadius: 12,
      headerBg: '#F8FAFC',
      headerColor: '#334155',
      rowHoverBg: '#F1F5F9',
      borderColor: '#F1F5F9',
    },
    Card: {
      borderRadius: 14,
      boxShadow: '0 4px 20px -2px rgba(15, 23, 42, 0.05)',
      colorBorderSecondary: '#F1F5F9',
    },
    Form: {
      labelColor: '#334155',
      labelFontSize: 14,
      labelHeight: 32,
    },
    Modal: {
      borderRadius: 16,
      boxShadow: '0 20px 40px -15px rgba(15, 23, 42, 0.25)',
    },
    Notification: {
      borderRadius: 12,
    },
    Message: {
      borderRadius: 10,
    },
  },
};

export const darkTheme = {
  token: {
    colorPrimary: '#6366F1',
    colorBgBase: '#0F172A',
    colorBgContainer: '#1E293B',
    colorBgElevated: '#334155',
    colorBorder: '#334155',
    colorBorderSecondary: '#1E293B',
    colorTextBase: '#F8FAFC',
    colorTextSecondary: '#94A3B8',
    colorTextTertiary: '#64748B',
  },
};

